import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoiceDollar, faFolderOpen, faFolderClosed, faClock, faUser, faIdCard, faShippingFast, faCalendarAlt, faFileImport, faCheckCircle, faTasks, faMoneyBillWave } from '@fortawesome/free-solid-svg-icons';

const Header = ({ data, requestNumber }) => {

   // Extract and trim container numbers, then join with ', '
   const containerNumbers = data.container_data?.map(container => container.container_number.trim()).join(', ') ?? '';

   // Extract and trim bill of lading numbers, then join with ', '
   const bolNumbers = data.bill_of_lading_data?.map(bol => bol.bill_of_lading.trim()).join(', ') ?? '';
 
   // Merge containerNumbers and bolNumbers into a single string, separated by ' | ' if both exist
   const customerReferences = [containerNumbers, bolNumbers].filter(ref => ref).join(' | ');


  return (
    <div className="bg-white shadow rounded-lg overflow-hidden mb-2 p-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Left Column */}
        <div>
          <h2 className="text-xl font-semibold mb-2 text-blue-900 flex items-center">
            <FontAwesomeIcon icon={faFileInvoiceDollar} className="text-blue-500 mr-2" /> Details
          </h2>
          { /* Each Row With Divider */}
          <div className="mb-1">
            <div className="grid grid-cols-2 gap-4">
              <span className="font-medium text-gray-600 flex items-center">
                <FontAwesomeIcon icon={faFolderOpen} className="text-gray-500 mr-2" /> Request Number:
              </span>
              <span className="text-gray-800">{requestNumber || data.requestNumber}</span>
            </div>
            <hr className="my-2" />
          </div>

          <div className="mb-1">
            <div className="grid grid-cols-2 gap-4">
              <span className="font-medium text-gray-600 flex items-center">
                <FontAwesomeIcon icon={faFolderClosed} className="text-gray-500 mr-2" /> Reference:
              </span>
              <span className="text-gray-800">{data.reference}</span>
            </div>
            <hr className="my-2" />
          </div>

          <div className="mb-1">
            <div className="grid grid-cols-2 gap-4">
              <span className="font-medium text-gray-600 flex items-center">
                <FontAwesomeIcon icon={faUser} className="text-gray-500 mr-2" /> Customer:
              </span>
              <span className="text-gray-800">{data.customer}</span>
            </div>
            <hr className="my-2" />
          </div>

          <div className="mb-1">
            <div className="grid grid-cols-2 gap-4">
              <span className="font-medium text-gray-600 flex items-center">
                <FontAwesomeIcon icon={faIdCard} className="text-gray-500 mr-2" /> Customer RFC:
              </span>
              <span className="text-gray-800">{data.customer_rfc}</span>
            </div>
            <hr className="my-2" />
          </div>

          <div>
            <div className="grid grid-cols-2 gap-4">
              <span className="font-medium text-gray-600 flex items-center">
                <FontAwesomeIcon icon={faShippingFast} className="text-gray-500 mr-2" /> Customer Ref:
              </span>
              <span className="text-gray-800">{customerReferences}</span>
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div>
          <h2 className="text-xl font-semibold mb-2 text-blue-900 flex items-center">
            <FontAwesomeIcon icon={faCalendarAlt} className="text-blue-500 mr-2" /> Date & Pedimento
          </h2>

          { /* Repeating the pattern for the right column */}
          <div className="mb-1">
            <div className="grid grid-cols-2 gap-4">
              <span className="font-medium text-gray-600 flex items-center">
                <FontAwesomeIcon icon={faClock} className="text-gray-500 mr-2" /> Date:
              </span>
              <span className="text-gray-800">{data.date}</span>
            </div>
            <hr className="my-2" />
          </div>

          <div className="mb-1">
            <div className="grid grid-cols-2 gap-4">
              <span className="font-medium text-gray-600 flex items-center">
                <FontAwesomeIcon icon={faFileImport} className="text-gray-500 mr-2" /> Pedimento:
              </span>
              <span className="text-gray-800">{data.pedimento}</span>
            </div>
            <hr className="my-2" />
          </div>

          <div className="mb-1">
            <div className="grid grid-cols-2 gap-4">
              <span className="font-medium text-gray-600 flex items-center">
                <FontAwesomeIcon icon={faCheckCircle} className="text-gray-500 mr-2" /> Pedimento Status:
              </span>
              <span className="text-gray-800">{data.status_pedimento}</span>
            </div>
            <hr className="my-2" />
          </div>

          <div>
            <div className="grid grid-cols-2 gap-4">
              <span className="font-medium text-gray-600 flex items-center">
                <FontAwesomeIcon icon={faTasks} className="text-gray-500 mr-2" /> Status Modulacion:
              </span>
              <span className="text-gray-800">{data.status_modulacion}</span>
            </div>
            <hr className="my-2" />

          </div>
          {data.advanceBalance !== undefined && (
            <div className="mb-1">
              <div className="grid grid-cols-2 gap-4">
                <span className="font-medium text-gray-600 flex items-center">
                  <FontAwesomeIcon icon={faMoneyBillWave} className="text-gray-500 mr-2" /> Advance Balance:
                </span>
                <span className="text-gray-800">{data.advanceBalance}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
